/**
 * Орох хөдөлгөөн (dark glass) — блок доороос гарч ирнэ, 160ms шатлалтай.
 * `i` нь дарааллын дугаар (`index.css` → `.rise`). Дашбоард, касс.
 *
 * ⚠️ Элемент DOM-д ОРОХ агшинд НЭГ удаа ажиллана. Касс дээр маягтыг
 *    `key`-ээр цэвэрлэдэг тул `Rise`-ийг key-тэй компонентын ГАДНА
 *    тавина — эс тэгвээс борлуулалт бүрийн дараа карт дахин «үсэрнэ».
 */

import type { CSSProperties, ReactNode } from 'react';

export function Rise({ i, shine = false, className = '', children }: {
  i: number;
  /** Цагаан гялбаа нэг удаа гүйнэ (KPI) */
  shine?: boolean;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      style={{ '--i': i } as CSSProperties}
      className={`rise ${shine ? 'shine rounded-card' : ''} ${className}`}
    >
      {children}
    </div>
  );
}
